module.exports = "/static/media/lineto-circular-bold.8bcdcb13.woff2";